import React , {Component} from 'react';
import backIcon from './../assets/images/icons/back-2.svg';
import mapIcon from './../assets/images/icons/map.svg';
import motorbikeIcon from './../assets/images/icons/motorbike.svg';
import timerIcon from './../assets/images/icons/timer.svg';
import * as axios from "axios/index";
import * as vars from './Vars';
//import NewAddress from './section/NewAddressV3';
import NewAddress from './section/NewAddressV3MapIr';
import Loader from './loader/OrderAddressLoader';
import {Link} from "react-router-dom";
import AddressCard from "./section/OrderAddressCard";
import NumberFormat from 'react-number-format';
import { Swiper } from 'swiper';
import forwardIcon from './../assets/images/icons/forward.svg';


class OrderAddressV3 extends Component{

    constructor(props){

        super(props)
        this.state = {
            branchSlug : "",
            newAddress : false ,
            requestLoading : true ,
            addresses : [] ,
            selectedAddress : null,


            deliverySensitive : null ,
            deliverySensitiveFrom : null ,


            deliveryPriceValue : null ,



        }
    }



    getNewAddress(address)
    {
        this.setState({
            addresses : [ address , ...this.state.addresses]
        })
        this.selectedAddressChange(address.id)

    }

    selectedAddressChange(selectedId){


        this.state.addresses.map((address , index) => {
            if (address.id === selectedId && address.available === true)
            {

                this.setState({
                    selectedAddress : selectedId ,
                })
                localStorage.setItem("selectedAddress" , address.id)
                localStorage.setItem("selectedAddressTitle" , address.title)
                localStorage.setItem("selectedAddressBody" , address.body)

                this.setState({
                    deliverySensitive : address.normalPricing.sensitive ,
                    deliverySensitiveFrom : address.normalPricing.sensitive_from ,
                    deliveryPriceValue : address.normalPricing.price_a ,
                })

                if (address.normalPricing.sensitive === true && localStorage.getItem("totalPayablePrice") >= address.normalPricing.sensitive_from)
                {
                    this.setState({
                        deliveryPriceValue : 0
                    })
                }


            }
        })
    }

    componentDidMount(){
        let data = new FormData()
        let branchSlug = localStorage.getItem("branchSlug")
        this.setState({
            branchSlug : branchSlug
        })
        data.append('api_token' , localStorage.getItem("api_token") )
        axios.post(vars.Url +'api/v3/address/' + branchSlug , data , {
            params : {
            }

        } )
            .then(response => {
                let data = response.data.data
                this.setState({
                    requestLoading : false ,
                    addresses : [...data.addresses] ,
                })
                if (Object.keys(data.addresses).length > 0)
                {
                    this.selectedAddressChange(data.addresses[0].id)
                }
            })
            .catch( (error) => {
                let data = error.response.data.data
            })
    }

    newAddressHandler(){
        this.setState({
            newAddress: !this.state.newAddress
        })
    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.addresses !== this.state.addresses )
        {
            let addressSlier = new Swiper('#address-slider', {
                slidesPerView: 1.3,
                spaceBetween: 10,
            });
        }
    }


    render(){
        return(
            <div id="main-custom-1" className="text-decoration-none">
                <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Link to="/cart">
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>

                                            <span className="title">
                                                آدرس و تحویل
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">
                            <div className="items-container items-container-custom-1 has-fixed-footer-1">

                                {
                                    this.state.requestLoading === true ?
                                        (
                                            <div>
                                                <Loader />
                                            </div>
                                        )
                                        :
                                        (
                                            <div>
                                                <div className="row no-gutters justify-content-between align-items-center">
                                                    <div className="col-auto">
                                                        <div className="title-custom-2">
                                                            <img src={mapIcon} alt="map" className="item-icon" />
                                                            <span className="title">
                                                        آدرس انتخابی شما
                                                    </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <button className="btn btn-custom-6" onClick={this.newAddressHandler.bind(this)}>
                                                            <i className="fas fa-plus btn-item-icon" />
                                                            <span className="btn-title">
                                                            آدرس جدید
                                                        </span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">

                                                    <div className="col">

                                                        <div className="swiper-container" id="address-slider" dir="rtl">
                                                            <div className="swiper-wrapper">
                                                                {this.state.addresses.map((object , index) =>
                                                                    <div className="swiper-slide" key={index} >
                                                                        <AddressCard selectedAddressChange={this.selectedAddressChange.bind(this)} object={object} selectedAddress={this.state.selectedAddress} />
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                                <div className="row no-gutters justify-content-between align-items-center mt-5">
                                                    <div className="col-auto">
                                                        <div className="title-custom-2">
                                                            <img src={motorbikeIcon} alt="motorbike" className="item-icon" />
                                                            <span className="title">
                                                            شیوه و زمان تحویل
                                                        </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-4 no-gutters">
                                                    <div className="col">
                                                        <div className="card-custom-8">
                                                            <div className="title">
                                                                تحویل با پیک
                                                            </div>
                                                            <div className="row no-gutters justify-content-between mt-2">
                                                                <div className="col-auto">

                                                                    <div className="row no-gutters">
                                                                        <div className="col-auto pl-2">
                                                                            <img src={timerIcon} alt="timer" className="item-icon" />
                                                                        </div>
                                                                        <div className="col">
                                                                            <div className="items">
                                                                                <div>
                                                                                 <span className="item-title">
                                                                                    سفارش برای
                                                                                 </span>
                                                                                    <span className="item-value">
                                                                                    {localStorage.getItem("orderDeliveryDateTitle")}
                                                                                 </span>
                                                                                </div>
                                                                                <div>
                                                                                <span className="item-value ">
                                                                                    {
                                                                                        localStorage.getItem("orderDeliveryTimeSelectedByUser") == 'false' ?
                                                                                            (
                                                                                                <div>
                                                                                                <span className="item-title">
                                                                                                    {localStorage.getItem("currentTimeDescription")}
                                                                                                </span>
                                                                                                </div>
                                                                                            )
                                                                                            :
                                                                                            (
                                                                                                <div>

                                                                                                 <span className="item-title">
                                                                                                     بین ساعت
                                                                                                 </span>
                                                                                                    {localStorage.getItem("orderDeliveryTimeTitle")}
                                                                                                </div>
                                                                                            )
                                                                                    }
                                                                                 </span>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div className="col-auto text-left">
                                                                    {
                                                                        this.state.deliveryPriceShow!== null ?
                                                                            (
                                                                                <div className="price-container">
                                                                                    <div className="price-title">
                                                                                        هزینه ارسال
                                                                                    </div>
                                                                                    <div className={"price-value " + (this.state.deliveryPriceValue === 0 ? "zero" : "")}>
                                                                                        {
                                                                                            this.state.deliveryPriceValue === 0 ?
                                                                                                (`رایگان`)
                                                                                                :
                                                                                                (
                                                                                                    <NumberFormat value={this.state.deliveryPriceValue} displayType={'text'} thousandSeparator={true}  />
                                                                                                )
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                            :
                                                                            (``)
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {
                                                    this.state.deliverySensitive === true ?
                                                        (
                                                            <div className="row no-gutters justify-content-end mt-2">
                                                                <div className="col-auto">
                                                                    <div className="content-custom-3">
                                                                        ارسال رایگان برای خریدهای بیش از
                                                                        <NumberFormat value={this.state.deliverySensitiveFrom} displayType={'text'} thousandSeparator={true} className="pl-2 pr-2" />
                                                                        تومان
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                        :
                                                        (``)
                                                }




                                            </div>

                                        )
                                }



                            </div>
                        </div>
                    </div>
                </div>


                {
                    this.state.selectedAddress !== null ?
                        (
                            <footer id="footer-3" className="text-decoration-none">
                                <div className="container p-0">
                                    <div className="row no-gutters justify-content-center">
                                        <div className="col-lg-6">
                                            <div className="items-container items-container-custom-1">

                                                <div className="row ">
                                                    <div className="col">
                                                        <Link to="/payment" className="btn btn-custom-5 btn-block">
                                                            ادامه  (شیوه پرداخت)
                                                            <img src={forwardIcon} alt="back" className="item-icon" />
                                                        </Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        )
                        :(``)
                }



                <NewAddress getNewAddress={this.getNewAddress.bind(this)} newAddress={this.state.newAddress} newAddressHandler={this.newAddressHandler.bind(this)} branchSlug={this.state.branchSlug}/>


            </div>
        )
    }
}

export default OrderAddressV3;